module.exports = __webpack_public_path__ + "static/media/gem-red.72ad0589.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/gem-red.svg
// module id = 510
// module chunks = 0